import { queryK2PriceActivity } from "@/graphql/promotion.gql";
import {
  Module,
  Mutation,
  Action,
  MutationAction
} from "vuex-module-decorators";
import { getPromotionStatus, sortPromotionList } from "@/utils/promotion";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { FORMAT_DATE_SMALL, isBegin } from "@/utils/common/date";
import { queryRequest, handlePaginationData } from "@/utils/request";
import { RootState } from "@/store";
import type { PaginationDataState } from "@/types";

export interface IPromotionState extends PaginationDataState {
  listData: any[];
}

@Module({ name: "PromotionListModule", namespaced: true })
export default class PromotionListModule
  extends PaginationModule<IPromotionState, RootState>
  implements IPromotionState {
  public paginationData: any = {
    pageSize: 1000, // pageSize = 1000 => 接口暂无状态排序，需手动排序
    pageNum: 1,
    totalCount: 0
  };
  public listData: any[] = [];
  public timers: Map<any, any> = new Map();

  @Mutation
  saveListDataMutation(data = []) {
    sortPromotionList(data, FORMAT_DATE_SMALL);
    this.listData = data;
  }
  @Mutation
  addListDataMutation(data = []) {
    this.listData.push(...data);
    sortPromotionList(this.listData, FORMAT_DATE_SMALL);
  }
  @Mutation
  addTimerMutation({ key = 0, value = "" } = {}) {
    this.timers.set(key, value);
  }
  @Mutation
  clearOneTimerMutation(key: any) {
    const timer = this.timers.get(key);
    if (timer) {
      clearInterval(timer);
      this.timers.delete(key);
    }
  }

  /**
   * 清除定时器
   */
  @Mutation
  clearTimersMutation() {
    this.timers.forEach(timer => timer && clearInterval(timer));
    this.timers.clear();
    console.log("销毁定时器");
  }

  @MutationAction({})
  public async testPromotion() {
    (this as any).commit("saveListDataMutation");
    return {};
  }

  @Action
  async initListAction() {
    let {
      state: {
        paginationData: { pageNum }
      }
    } = this.context;
    const { data: list = [], totalCount = 0 } = handlePaginationData(
      await queryRequest({
        query: queryK2PriceActivity,
        variables: { pageInput: { pageSize: 1000, pageNum } }
      })
    );

    let {
      commit,
      dispatch,
      state: { paginationData }
    } = this.context;
    commit(
      paginationData.pageNum === 1
        ? "saveListDataMutation"
        : "addListDataMutation",
      await dispatch("addCustomActivityFieldAction", list)
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  addCustomActivityFieldAction(list: any[]) {
    return list.map(item => {
      // 活动是否开始，false:未开始， true:已开始
      item._promotionIsBegin = isBegin(item.countDownStart, FORMAT_DATE_SMALL);
      // 添加活动状态
      item._promotionStatus = getPromotionStatus(
        item.countDownStart,
        item.countDownEnd,
        FORMAT_DATE_SMALL
      );
      return item;
    });
  }
}
